import { Box, Tooltip } from '@mui/material';
import type { JobStatus } from '@repo/api-gw-sdk';
import React from 'react';

import { JobStatuses } from '@/data/inventory/data';

export const JobStatusIcon = React.forwardRef(
  (
    {
      jobStatus,
      onClick,
      isStatic,
      hideTooltip,
    }: {
      jobStatus: JobStatus;
      onClick?: () => void;
      isStatic?: boolean;
      hideTooltip?: boolean;
    },
    ref
  ) => {
    const data = JobStatuses[jobStatus];
    if (!data) {
      return null;
    }

    return (
      <Tooltip title={hideTooltip ? undefined : data.title}>
        <Box
          ref={ref}
          onClick={onClick}
          component={'span'}
          className='rounded-full inline-flex p-[2px]'
          sx={{
            background: data.backgroundColor,

            '& i': {
              background: data.iconColor,
            },
          }}
        >
          <i
            className={`${isStatic && data.staticIcon ? data.staticIcon : data.icon} h-[20px] w-[20px]`}
          />
        </Box>
      </Tooltip>
    );
  }
);
